import React from 'react';
import styles from './FindPasswordSuccessPanel.module.css'; 
import { InnocodeButton } from '@intsoft/innocode-core';

function FindPasswordSuccessPanel({ onNext }) {
  return (
    <div className={styles.content_wrapper}>
      <div className={styles.signup_section}>
        <div className={styles.success_content}>
          <div className={styles.icon_box}>
            <img
              src="/assets/circles_success-icon.svg"
              alt="success-icon"
              className={styles.success_icon}
            />
          </div>
          <div className={`innocode-typography--title-sm innocode-typography--bold ${styles.title_text}`}>
            비밀번호가
            <br />
            성공적으로 변경되었습니다!
          </div>
          <div className={`innocode-typography--body-sm-reading innocode-typography--semibold ${styles.description_text}`}>
            이제 간편 로그인을 통해 서비스를
            <br />
            편리하게 이용해보세요!
          </div>
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton size="lg" onClick={onNext} className={styles.submit_btn}>
          완료
        </InnocodeButton>
        {/* <button
          type="button"
          className={` ${styles.submit_btn}`}
          onClick={onNext}
        >
          <span  >완료</span>
        </button> */}
      </div>
    </div>
  );
}
export default FindPasswordSuccessPanel;